import "./Header.css";

function Header(): JSX.Element {
    return (
        <section className="header" id="headerDiv">
            <h1 className="Title">My_Notes</h1>
        </section>
    )
}

export default Header;